var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4 8)",
    fill: "#E59F33"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 9h4a4 4 0 0 1 4 4v3H0v-3a4 4 0 0 1 4-4z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 4,
    r: 4
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#1C1A37",
    d: "M.5 2.5h20v21H.5z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.5.5v2c0 .552-.224 1.052-.586 1.414A1.994 1.994 0 0 1 2.5 4.5a1.994 1.994 0 0 1-1.414-.586A1.994 1.994 0 0 1 .5 2.5v-2h4z",
    stroke: "#1C1A37",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1C1A37",
    cx: 2.5,
    cy: 2.5,
    r: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUser);
export default __webpack_public_path__ + "static/media/ic_user.e927bcd3ca51354a5b56dea44706f9d8.svg";
export { ForwardRef as ReactComponent };